import React, { useState, useEffect } from 'react'
import { TextField, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { t } from 'ttag'

// Import custom components
import YumCancelButton from '../../../../components/YumCancelButton/YumCancelButton'
import YumSubmitButton from '../../../../components/YumSubmitButton/YumSubmitButton'
import YumButtonGroup from '../../../../components/YumButtonGroup/YumButtonGroup'
import DiscardConfirmationModal from '../DiscardConfirmationModal/DiscardConfirmationModal'

// Import custom SVG icons
import { ReactComponent as WalkingIcon } from '../../../../assets/activity-types/walking-active.svg'
import { ReactComponent as RunningIcon } from '../../../../assets/activity-types/running-active.svg'
import { ReactComponent as CyclingIcon } from '../../../../assets/activity-types/cycling-active.svg'
import { ReactComponent as ExerciseIcon } from '../../../../assets/activity-types/exercise-active.svg' // for hiking
import { ReactComponent as YogaIcon } from '../../../../assets/activity-types/yoga-active.svg'
import { ReactComponent as CustomIcon } from '../../../../assets/activity-types/custom-active.svg' // for other
import { WorkoutType } from '../../../../plugins/ActivityTrackerPlugin'
import { getWorkoutLabel } from '../../../../common/workoutActivities'
import { YumActivityIcon } from '../../../../components/YumActivityIcon/YumActivityIcon'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import { currentLocale } from '../../../../i18nInit'
import { formatDuration } from '../ActivityItem/ActivityItem'

// Helper function to convert WorkoutType to CustomTypeCategory for YumActivityIcon
const workoutTypeToCustomTypeCategory = (workoutType: WorkoutType): CustomTypeCategory => {
  switch (workoutType) {
    case 'walking':
      return CustomTypeCategory.WALKING
    case 'running':
    case 'running.treadmill':
      return CustomTypeCategory.RUNNING
    case 'biking':
    case 'biking.stationary':
      return CustomTypeCategory.CYCLING
    case 'swimming':
    case 'swimming.pool':
    case 'swimming.open_water':
      return CustomTypeCategory.SWIMMING
    case 'yoga':
      return CustomTypeCategory.YOGA
    default:
      return CustomTypeCategory.EXERCISE
  }
}

// Styles converted from SCSS to makeStyles
const useStyles = makeStyles((theme) => ({
  workoutConfirmationView: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  confirmationHeader: {
    /*position: 'sticky',
    //zIndex: 1000,
    //marginLeft: '-16px',
    //marginRight: '-16px',
    //top: '-16px',
    top: 0,
    left: 0,
    right: 0,
    padding: 0,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',*/
  },
  headerTitle: {
    //padding: '16px',
    //margin: '0 16px',
    //background: 'white',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //marginBottom: '24px',
  },
  confirmationContent: {
    /*paddingTop: '70px',
    paddingBottom: '60px', // Add padding to prevent content from being hidden behind fixed buttons*/
  },
  formSection: {
    //marginBottom: '24px',
  },
  sectionTitle: {
    margin: '0 0 12px 0',
    fontSize: '17px',
    fontWeight: 600,
    color: '#333',
  },
  titleInput: {
    background: 'white',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '12px',
    fontSize: '16px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  divider: {
    height: '1px',
    background: '#C6C6CC',
  },
  confirmationActions: {
    /*position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    padding: '16px 20px',
    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    // iOS Safari safe area support
    '@supports (bottom: constant(safe-area-inset-bottom))': {
      paddingBottom: 'calc(16px + constant(safe-area-inset-bottom))',
    },
    '@supports (bottom: env(safe-area-inset-bottom))': {
      paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
    },*/
  },
  typeGrid: {
    padding: 0,
  },
  typeButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60px',
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #e5e5ea',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    gap: '4px',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    '&.selected': {
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },
    '& span': {
      fontSize: '12px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },
  },
  summaryGrid: {
    padding: 0,
  },
  summaryCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3px',
    /*borderRadius: '12px',
    padding: '16px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    minHeight: '100px',*/
  },
  summaryValue: {
    fontSize: '40px',
    fontWeight: 700,
    textAlign: 'center',
  },
  summaryValueSmall: {
    fontSize: '32px',
    fontWeight: 700,
    textAlign: 'center',
  },
  summaryTitle: {
    fontSize: '12px',
    //color: '#666',
    textAlign: 'center',
    //fontWeight: 500,
  },
  detailsContainer: {
    //backgroundColor: 'white',
    /*borderRadius: '12px',
    padding: '16px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',*/

    borderTop: '1px solid #C6C6CC',
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
    '&:not(:last-child)': {
      borderBottom: '1px solid var(--ion-color-light-shade)',
      paddingBottom: '8px',
      marginBottom: '8px',
    },
  },
  detailLabel: {
    fontSize: '16px',
    color: 'var(--ion-color-medium-shade)',
    fontWeight: 400,
  },
  detailValue: {
    fontSize: '17px',
    fontWeight: 500,
    color: 'var(--ion-text-color)',
  },
  // Responsive styles for mobile
  '@media (max-width: 480px)': {
    confirmationActions: {
      /*padding: '12px 16px',
      '@supports (bottom: constant(safe-area-inset-bottom))': {
        paddingBottom: 'calc(12px + constant(safe-area-inset-bottom))',
      },
      '@supports (bottom: env(safe-area-inset-bottom))': {
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom))',
      },*/
      '@supports (bottom: constant(safe-area-inset-bottom))': {
        paddingBottom: 'calc(constant(safe-area-inset-bottom))',
      },
      '@supports (bottom: env(safe-area-inset-bottom))': {
        paddingBottom: 'calc(env(safe-area-inset-bottom))',
      },
    },
    /*summaryCard: {
      padding: '12px !important',
      minHeight: '80px !important',
      '& $summaryValue': {
        fontSize: '18px !important',
      },
    },*/
    typeButton: {
      minHeight: '50px !important',
      padding: '6px !important',
      '& ion-icon': {
        fontSize: '18px !important',
      },
      '& span': {
        fontSize: '11px !important',
      },
    },
  },
}))

// Workout Type definitions to match Swift enum
/*export enum WorkoutType {
  WALKING = 'walking',
  RUNNING = 'running',
  CYCLING = 'cycling',
  SWIMMING = 'swimming',
  YOGA = 'yoga',
  OTHER = 'other',
}*/

export interface WorkoutTypeConfig {
  displayName: string
  IconComponent: React.ComponentType<any>
  color: string
}

// Workout type configurations matching Swift implementation
/*export const WORKOUT_TYPE_CONFIG: Record<WorkoutType, WorkoutTypeConfig> = {
  [WorkoutType.WALKING]: {
    displayName: t`Walking`,
    IconComponent: WalkingIcon,
    color: '#007AFF', // blue
  },
  [WorkoutType.RUNNING]: {
    displayName: t`Running`,
    IconComponent: RunningIcon,
    color: '#FF3B30', // red
  },
  [WorkoutType.CYCLING]: {
    displayName: t`Cycling`,
    IconComponent: CyclingIcon,
    color: '#34C759', // green
  },
  [WorkoutType.SWIMMING]: {
    displayName: t`Swimming`,
    IconComponent: ExerciseIcon,
    color: '#FF9500', // orange
  },
  [WorkoutType.YOGA]: {
    displayName: t`Yoga`,
    IconComponent: YogaIcon,
    color: '#AF52DE', // purple
  },
  [WorkoutType.OTHER]: {
    displayName: t`Other`,
    IconComponent: CustomIcon,
    color: '#8E8E93', // gray
  },
}*/

export interface WorkoutConfirmationData {
  title: string
  type: WorkoutType
  duration: number // in seconds
  distance: number // in meters
  calories: number
  steps: number // step count during workout
  startTime: Date
  endTime: Date
  locations?: any[] // GPS locations array
}

interface WorkoutConfirmationViewProps {
  confirmationData: WorkoutConfirmationData
  onSave: (updatedData: { title: string; type: WorkoutType }) => void
  onDiscard: () => void
}

// Helper component for summary cards
const SummaryCard: React.FC<{
  title: string
  value: string
  classes: any
  small?: boolean
}> = ({ title, value, classes, small }) => (
  <div className={classes.summaryCard}>
    <div className={classes.summaryTitle}>{title}</div>
    <div className={small ? classes.summaryValueSmall : classes.summaryValue}>{value}</div>
  </div>
)

// Helper component for detail rows
const DetailRow: React.FC<{
  label: string
  value: string
  classes: any
}> = ({ label, value, classes }) => (
  <div className={classes.detailRow}>
    <span className={classes.detailLabel}>{label}</span>
    <span className={classes.detailValue}>{value}</span>
  </div>
)

// Utility functions to match Swift formatting
const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)

  //if (hours > 0) {
  return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  /*}
  return `${minutes}:${secs.toString().padStart(2, '0')}`*/
}

const formatDistance = (meters: number): string => {
  const km = meters / 1000
  return km.toFixed(2)
}

const formatTimeOnly = (date: Date): string => {
  return date.toLocaleTimeString(currentLocale, { hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

export const WorkoutConfirmationView: React.FC<WorkoutConfirmationViewProps> = ({
  confirmationData,
  onSave,
  onDiscard,
}) => {
  const classes = useStyles()
  const [editedTitle, setEditedTitle] = useState(confirmationData.title)
  const [editedType, setEditedType] = useState(confirmationData.type)
  const [showDiscardConfirmation, setShowDiscardConfirmation] = useState(false)

  useEffect(() => {
    // Initialize edited values when confirmation data changes
    setEditedTitle(confirmationData.title)
    setEditedType(confirmationData.type)
  }, [confirmationData])

  const handleSave = () => {
    onSave({
      title: editedTitle,
      type: editedType,
    })
  }

  const handleTypeSelect = (type: WorkoutType) => {
    setEditedType(type)
  }

  // Handle discard button click - show confirmation modal
  const handleDiscardClick = () => {
    setShowDiscardConfirmation(true)
  }

  // Handle discard confirmation - actually discard the workout
  const handleDiscardConfirm = () => {
    onDiscard()
  }

  // Handle discard confirmation modal close
  const handleDiscardConfirmationClose = () => {
    setShowDiscardConfirmation(false)
  }

  return (
    <div className={classes.workoutConfirmationView}>
      {/* Header */}
      <div className={classes.confirmationHeader}>
        <Typography variant="h6" className={classes.headerTitle}>
          <YumActivityIcon category={workoutTypeToCustomTypeCategory(editedType)} color="darkBlue" />
          <span style={{ marginLeft: '5px' }}>{getWorkoutLabel(editedType)}</span>
        </Typography>
      </div>

      {/* Scrollable Content */}
      {/*<div className={classes.confirmationContent}>*/}
      {/* Title Section */}
      {/*<div className="form-section">
          <Typography variant="subtitle1" className="section-title">
            {t`Workout Title`}
          </Typography>
          <TextField
            value={editedTitle}
            placeholder={t`Enter workout title`}
            onChange={(e) => setEditedTitle(e.target.value)}
            variant="outlined"
            fullWidth
            className="title-input"
          />
        </div>*/}

      {/* Type Section */}
      {/*<div className="form-section">
          <Typography variant="subtitle1" className="section-title">
            {t`Workout Type`}
          </Typography>
          <Grid container spacing={1} className="type-grid">
            {Object.entries(WORKOUT_TYPE_CONFIG).map(([typeKey, config]) => {
              const type = typeKey as WorkoutType
              const isSelected = editedType === type
              const { IconComponent } = config
              return (
                <Grid item xs={4} key={type}>
                  <div
                    className={`type-button ${isSelected ? 'selected' : ''}`}
                    style={{
                      backgroundColor: isSelected ? config.color : '#F2F2F7',
                      borderColor: config.color,
                    }}
                    onClick={() => handleTypeSelect(type)}
                  >
                    {IconComponent && (
                      <IconComponent
                        style={{
                          color: isSelected ? 'white' : config.color,
                          width: '20px',
                          height: '20px',
                        }}
                      />
                    )}
                    <span
                      style={{
                        color: isSelected ? 'white' : '#000',
                        fontSize: '12px',
                      }}
                    >
                      {config.displayName}
                    </span>
                  </div>
                </Grid>
              )
            })}
          </Grid>
        </div>*/}

      {/* Workout Summary */}
      <div className={classes.formSection}>
        {/*<Typography variant="subtitle1" className={classes.sectionTitle}>
            {t`Summary`}
          </Typography>*/}
        <Grid container spacing={2} className={classes.summaryGrid}>
          <Grid item xs={6}>
            <SummaryCard title={t`Duration`} value={formatDuration(confirmationData.duration)} classes={classes} />
          </Grid>
          <Grid item xs={6}>
            <SummaryCard
              title={t`Distance`}
              value={`${formatDistance(confirmationData.distance)} km`}
              classes={classes}
            />
          </Grid>
          {confirmationData.calories && confirmationData.calories > 0 ? (
            <Grid item xs={6}>
              <SummaryCard
                title={t`Calories`}
                value={Math.round(confirmationData.calories).toString()}
                classes={classes}
              />
            </Grid>
          ) : null}
          {confirmationData.steps && confirmationData.steps > 0 ? (
            <Grid item xs={6}>
              <SummaryCard title={t`Steps`} value={confirmationData.steps.toString()} classes={classes} />
            </Grid>
          ) : null}
          {/*<Grid item xs={6}>
              <SummaryCard
                title={t`Type`}
                value={WORKOUT_TYPE_CONFIG[editedType].displayName}
                IconComponent={WORKOUT_TYPE_CONFIG[editedType].IconComponent}
                color={WORKOUT_TYPE_CONFIG[editedType].color}
              />
            </Grid>*/}
        </Grid>
      </div>

      <div className={classes.divider}></div>

      <Grid container spacing={2} className={classes.summaryGrid}>
        <Grid item xs={6}>
          <SummaryCard
            title={t`Start time`}
            value={formatTimeOnly(confirmationData.startTime)}
            classes={classes}
            small={true}
          />
        </Grid>
        <Grid item xs={6}>
          <SummaryCard
            title={t`End time`}
            value={formatTimeOnly(confirmationData.endTime)}
            classes={classes}
            small={true}
          />
        </Grid>
      </Grid>

      {/* Fixed Bottom Buttons */}
      <div className={classes.confirmationActions}>
        <YumButtonGroup>
          <YumCancelButton onClick={handleDiscardClick} text={t`Discard`} color="error" />
          <YumSubmitButton onClick={handleSave} text={t`Save`} />
        </YumButtonGroup>
      </div>

      {/* Discard Confirmation Modal */}
      <DiscardConfirmationModal
        open={showDiscardConfirmation}
        onClose={handleDiscardConfirmationClose}
        onConfirm={handleDiscardConfirm}
      />
    </div>
  )
}

export default WorkoutConfirmationView
